import { render } from "./BannerListComponent.vue?vue&type=template&id=165ab3bc"
import script from "./BannerListComponent.vue?vue&type=script&lang=js"
export * from "./BannerListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__